export default __webpack_public_path__ + "static/Hyundai Solaris-46864289a72c3bb595cf4899748dbbfe.jpg";